import { i18n } from '@lingui/core'
import { nl } from 'make-plural/plurals'
import { useEffect, useState } from 'react'

import { tenantSlugs } from '@/modules/healthblocks/ServerProvider'
import { useLocale } from './locale-atom'
import { messages as nlShared } from './locales/nl/shared/messages.po'

import type { TenantSlug } from '@/modules/healthblocks/ServerProvider'

// Immediately load shared translations
i18n.load('nl', nlShared)
i18n.loadLocaleData({ nl: { plurals: nl } })
i18n.activate('nl')

let activated: TenantSlug | undefined
let loading: TenantSlug | undefined

export function useTenantLocaleSync(tenant: TenantSlug) {
  const locale = useLocale()
  const rerender = useState('')[1]
  useEffect(() => {
    // Only consider valid tenants
    if (!tenant || !tenantSlugs.includes(tenant)) return
    // Already loading
    if ((tenant === activated || tenant === loading) && locale === i18n.locale) return
    loading = tenant
    import(`./locales/${locale}/${tenant}/messages.po`)
      .then(({ messages }) => {
        i18n.load(locale, messages)
        i18n.activate(locale)
        activated = tenant
        // This should not be necessary, but there needs to be some state change to apply
        // the new locale to components that do not use useLingui()
        rerender(locale)
        // console.log('activated', tenant, locale, mod.messages)
      })
      .catch((error) => {
        console.error('Failed to load translations:', error)
      })
      .finally(() => {
        loading = undefined
      })
  }, [tenant, locale])
  return locale
}

//     import(`../locales/${locale}/${tenant}/messages.mjs`)
//       .then((mod) => {
//         i18n.load(locale, mod.messages)
//         i18n.activate(locale)
//         setActivatedTenant(tenant)
//         console.log(
//           'i18n.azt',
//           i18n.locale,
//           i18n.locales,
//           i18n.messages,
//           tenant,
//           activatedTenant
//         )
//       })
//       .catch((error) => {
//         console.error('Failed to load translations:', error)
//       })
//   }, [tenant, locale])

//   if (tenant && tenant !== activatedTenant) {
//     // You might want to show a loading spinner here
//     console.log(
//       'i18n.locales2',
//       i18n.locale,
//       i18n.locales,
//       i18n.messages,
//       tenant,
//       activatedTenant
//     )
//     return <div>Loading tenant translations... {tenant}</div>
//   }

//   return <LinguiI18nProvider i18n={i18n}>{children}</LinguiI18nProvider>
// }

// export { I18nProvider }
